export const getClubPublicKey = (clubOrKey) => {
    if (!clubOrKey) {
        return '';
    }

    if (typeof clubOrKey === 'string' || typeof clubOrKey === 'number') {
        return String(clubOrKey);
    }

    return clubOrKey.publicKey || clubOrKey.clubId?.toString() || '';
};

export const getClubPublicPath = (clubOrKey) => {
    const clubKey = getClubPublicKey(clubOrKey);
    return clubKey ? `/clubs/${encodeURIComponent(clubKey)}` : '/clubs';
};

export const getClubStorefrontPath = (clubOrKey) => {
    const clubKey = getClubPublicKey(clubOrKey);
    return clubKey ? `/clubs/${encodeURIComponent(clubKey)}/storefront` : '/clubs';
};
